<div
  id="preferences-page"
  [style.height]="pageHeight + 'px'">
  <topo-tabs
    class="tab-bar"
    [selectedTabIndex]="selectedTabIndex"
    [tabs]="tabs"
    (selectedTabIndexChanged)="tabChanged($event)"
    [fillSpace]="false"
    [tabCssClass]="isHorizonApp && 'horizon-styled-tab'"></topo-tabs>

  <section
    class="form-controls-container"
    [formGroup]="form">
    <div
      class="contact-info-form-container"
      [class.active]="isDesktop || selectedTabIndex === 0">
      @if (!!form) {
        <topo-contact-info-form
          [form]="form"
          [dataset]="dataset"
          [document]="document"
          [editView]="editView"
          [isUserAccountLinked]="isUserAccountLinked"
          (documentChanged)="documentChanged($event)"
          (editProfileClicked)="editProfile()"></topo-contact-info-form>
      }
    </div>
    @if (availableChannels?.length) {
      <div
        class="pref-settings-container"
        [class.active]="isDesktop || selectedTabIndex === 1">
        <topo-preference-settings
          [availableChannels]="availableChannels"
          [form]="form"
          [isDesktop]="isDesktop"></topo-preference-settings>
      </div>
    }
  </section>

  <div class="form-footer">
    <topo-app-disclaimer />

    <div class="form-actions-container">
      @if (hasCancel) {
        <button
          class="button is-secondary"
          [style.width]="isDesktop ? '96px' : '50%'"
          (click)="cancelClick()">
          {{ 'NOTIFICATION-PREFERENCES.CANCEL' | translate }}
        </button>
      }
      <button
        class="button is-primary"
        [style.width]="isDesktop ? '96px' : '50%'"
        (click)="saveClick()"
        [disabled]="form.invalid">
        {{ 'NOTIFICATION-PREFERENCES.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>

<topo-edit-profile
  [active]="editProfileActive"
  [profilePreferences]="form.value"
  (complete)="editProfileComplete($event)"
  (close)="editProfileClose()"></topo-edit-profile>

<topo-register-email [isDesktop]="isDesktop"></topo-register-email>

@if (showRegisterPhone$ | async) {
  <topo-register-phone [isDesktop]="isDesktop" />
}

@if (showRegisterWhatsApp$ | async) {
  <topo-register-whatsapp [isDesktop]="isDesktop" />
}
